import People from "../../assets/People.png"
import Button from "../Shared/Button"
import { Link } from "react-router-dom"
const FindQuestion = () => {
  return (
    <div className="container">
      <div className="bg-[#F8F8F8] rounded-[40px] w-full lg:h-[500px] md:h-[450px] sm:h-[420px] h-[390px] flex flex-col items-center justify-center text-center">
        <div className="container">
        <h1 className="md:text-5xl sm:text-4xl text-2xl font-extrabold">Have a question?<br />
          We are here to help</h1>
        <img className="sm:mb-5 mb-4 md:mt-9 sm:mt-7 mt-5 mx-auto w-[148px]" src={People} alt="" />
        <p className="mb-5 max-w-[247px] font-medium sm:text-base text-sm mx-auto">Our customer support is available monday to friday: 9AM - 5PM.</p>
      <Link to="/contact-us">
      <Button variant="light" className="!rounded-[20px] sm:!h-[55px] !h-12 sm:!text-base !text-sm w-[196px] mx-auto !bg-[#1F1F1F] !text-white hover:!bg-white hover:!text-secondary hover:border-secondary">Contact us</Button>
      </Link>
        </div>
      </div>
    </div>
  )
}

export default FindQuestion